import React from "react";
import classNames from "classnames/bind";
import styles from "./DateRangeSelector.module.scss";
import { AssertIsSameRange } from "../utils/assert";
import { CustomDateRangeProps } from "./types";

const cx = classNames.bind(styles);

const CustomDateRange = ({
  dateRanges,
  onClick,
  currentRange,
}: CustomDateRangeProps) => {
  const handleClick = (from: Date, to: Date) => {
    onClick({ from, to });
  };

  return (
    <div>
      {dateRanges.map((dateRange) => (
        <div
          key={dateRange.label}
          className={cx("dateRange", {
            "dateRange--active": AssertIsSameRange(
              dateRange,
              currentRange as { from: Date; to: Date }
            ),
          })}
          onClick={() => handleClick(dateRange.from, dateRange.to)}
        >
          {dateRange.label}
        </div>
      ))}
    </div>
  );
};

export default CustomDateRange;
